import { checkPermission, hasAdminAccess, permissionType } from "../common/Functions";

export const FINANCE_MANAGEMENT_BASE_PATH = "/finance-management";

export const SALARY_MANAGEMENT_TABS = [
  { key: "sheets", label: "Monthly Salary Sheets", permission: permissionType.FINANCE_MANAGEMENT },
  { key: "salary", label: "Salary Management", permission: permissionType.FINANCE_MANAGEMENT },
  { key: "records", label: "Employee Salary Records", permission: permissionType.FINANCE_MANAGEMENT },
  { key: "deductions", label: "Deductions & Taxes", permission: permissionType.FINANCE_MANAGEMENT },
];

export const FINANCE_OVERVIEW_TABS = [
  { key: "dashboard", label: "Finance Summary", permission: permissionType.FINANCE_MANAGEMENT },
  {
    key: "expenses",
    label: "Expenses Management",
    permission: permissionType.FINANCE_EXPENSES,
    /** Pass if any listed module+key combo matches (supports office-only access). */
    anyPermissionChecks: [
      { moduleId: permissionType.FINANCE_EXPENSES, keys: ["read", "office_read"] },
      { moduleId: permissionType.FINANCE_DOCUMENTS, keys: ["read"] },
    ],
  },
];

export const FINANCE_MANAGEMENT_TABS = [...SALARY_MANAGEMENT_TABS, ...FINANCE_OVERVIEW_TABS];

const SALARY_TAB_KEYS = new Set(SALARY_MANAGEMENT_TABS.map((tab) => tab.key));
const FINANCE_OVERVIEW_TAB_KEYS = new Set(FINANCE_OVERVIEW_TABS.map((tab) => tab.key));

export const getFinancePageSection = (tabKey) =>
  FINANCE_OVERVIEW_TAB_KEYS.has(tabKey) ? "finance" : "salary";

export const getFinanceSectionTabs = (section) =>
  section === "finance" ? FINANCE_OVERVIEW_TABS : SALARY_MANAGEMENT_TABS;

export const canReadFinanceManagementTab = (user, tab) => {
  if (hasAdminAccess(user)) return true;
  if (Array.isArray(tab.anyPermissionChecks) && tab.anyPermissionChecks.length) {
    return tab.anyPermissionChecks.some(({ moduleId, keys }) =>
      (keys || ["read"]).some((key) => checkPermission(moduleId, key))
    );
  }
  const permissions = tab.anyPermissions?.length ? tab.anyPermissions : [tab.permission];
  return permissions.some((permissionId) => checkPermission(permissionId, "read"));
};

export const getFinanceManagementTabPath = (tabKey) =>
  `${FINANCE_MANAGEMENT_BASE_PATH}/${tabKey}`;

export const getFinanceTabKeyFromPath = (pathname) => {
  const path = String(pathname || "");
  if (path.includes("/finance-management/expenses")) {
    return "expenses";
  }
  const match = path.match(/\/finance-management\/([^/]+)/);
  return match?.[1] || "sheets";
};

export const getFinanceManagementTabFromPath = (pathname, allowedTabKeys) => {
  const tabKey = getFinanceTabKeyFromPath(pathname);
  if (tabKey && allowedTabKeys.includes(tabKey)) return tabKey;
  return allowedTabKeys[0] || "sheets";
};

export const isSalaryManagementTab = (tabKey) => SALARY_TAB_KEYS.has(tabKey);

export const isFinanceOverviewTab = (tabKey) => FINANCE_OVERVIEW_TAB_KEYS.has(tabKey);
